




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class DocIcon extends Vue {
  @Prop({ default: '' }) iconName!: string;
  @Prop({ default: '' }) iconTheme!: string;
  @Prop({ default: '' }) iconSize!: string;
}
